import { Button, Card, Container, Divider, FormControlLabel, Paper, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { Link, Navigate, redirect, useLocation, useParams } from 'react-router-dom';
import { Stack } from '@mui/system';

import lcc_logo from "../../images/lcc_logo.png"
import Loading from '../../components/Loading';
import { useSelector } from 'react-redux';
import Login from '../../features/auth/login';

function useQuery() {
    const { search } = useLocation();
  
    return React.useMemo(() => new URLSearchParams(search), [search]);
}
  
const FinderView = () => {
    const user = useSelector(state => state.auth.user)
    let params = useParams();
    let query = useQuery();

    var parent_rep_id = 0
    if(query.get("ref")) {
        parent_rep_id = parseInt(query.get("ref"))
    }

    var reglink = ""
    if (parent_rep_id !== 0) {
        reglink = <center><Button component={Link} to={`/finders/register?ref=${parent_rep_id}`} variant="contained" sx={{width: 250}}>Register for finder's fee</Button></center>
    }

    if (!user) {
        return <Stack spacing={2} sx={{margin: 2}}>
                    <Login />
            {reglink}
        </Stack>
    } else {
        return <Navigate to="/commissions/" />
    }

    return <></>;
}

export default FinderView;
